import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Purchase } from '../models/purchase.model';
import { environment } from '../../environments/environment';

interface CardPaymentData {
  card_data: {
    number: string;
    cvv: string;
    expiration_month: string;
    expiration_year: string;
  };
  holder_data: {
    name: string;
    cpf_cnpj: string;
  };
}

interface PixData {
  EncodedImage: string;
  Payload: string;
  ExpirationDate: string;
}

@Injectable({
  providedIn: 'root'
})
export class PurchaseService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getPurchases(): Observable<Purchase[]> {
    return this.http.get<Purchase[]>(`${this.apiUrl}/companies/me/purchases`);
  }

  getPurchaseById(id: string): Observable<Purchase> {
    return this.http.get<Purchase>(`${this.apiUrl}/companies/purchase/${id}`);
  }

  processCardPayment(purchaseId: string, paymentData: CardPaymentData): Observable<any> {
    return this.http.post(`${this.apiUrl}/companies/purchase/${purchaseId}/card-payment`, paymentData);
  }

  getPixData(purchaseId: string): Observable<PixData> {
    return this.http.get<PixData>(`${this.apiUrl}/companies/purchase/${purchaseId}/pix-data`);
  }
}
